// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"123":"3ec62422f09b1a8c","360":"8e73113b185b4040"}[chunkId] + ".js";
};